<template>
    <!-- <div>Ola {{$route.params}}</div> -->
    <div class="row">
        <div class="mx-auto col-md-12">
            <div class="card p-3 mb-3">
                <div class="card-body">
                    <b-card no-body class="mb-2">
                        <b-tabs v-model="tabIndex" card>
                            <b-tab title="Beneficiário" active>
                                <b-card-text>CPF: {{cpf_requerente}}</b-card-text>
                                <b-card-text>Nome: {{nome_completo}}</b-card-text>
                                <b-card-text>Situação:
                                    <b-badge v-if='form.ind_ativo == "A"' variant="success">Ativo</b-badge>
                                    <b-badge v-else-if='form.ind_ativo == "I"' variant="danger">Inativo</b-badge>
                                    <b-badge v-else-if='form.ind_ativo == "P"' variant="warning">Aguardando Confirmação</b-badge>
                                </b-card-text>
                            </b-tab>
                           <b-tab title="Responsável Anterior" v-if="respAnterior != null">
                                <b-card-text><strong>CPF: </strong>{{respAnterior.cpf_requerente}}</b-card-text>
                                <b-card-text><strong>Nome: </strong>{{respAnterior.nome_completo}}</b-card-text>
                                <b-card-text><strong>Nome da Mãe: </strong>{{respAnterior.nome_mae}}</b-card-text>
                                <b-card-text><strong>Data Nascimento: </strong>{{formatDate(respAnterior.data_nascimento)}}</b-card-text>
                            </b-tab>
                        </b-tabs>
                    </b-card>
                    <b-card v-if="tabIndex == 0"
                        class="mb-2"
                        header="Verifique e acerte os dados">
                        <b-form inline>

                            <div class="p-0 mb-3 col-12 d-md-flex">
                                <label class="mr-sm-1 col-md-2 p-0" for="nome_completo">Nome</label>
                                <b-form-input
                                    id="nome_completo"
                                    v-model="$v.form.nome_completo.$model"
                                    type="text"
                                    placeholder="Nome"
                                    required
                                    :class="`w-100` + ($v.form.nome_completo.$error ? ` is-invalid` : ``)"
                                    @keyup.native="removeAcentos($event)"
                                    :disabled="consulta"
                                ></b-form-input>
                            </div>

                            <div class="p-0 mb-3 col-12 d-md-flex">
                                <label class="mr-sm-1 col-md-2 p-0" for="data_nascimento">Data Nascimento</label>
                                <b-form-input
                                    id="data_nascimento"
                                    v-model="form.data_nascimento"
                                    type="date"
                                    required
                                    :class="($v.form.data_nascimento.$error ? ` is-invalid` : ``)"
                                    :disabled="consulta"
                                ></b-form-input>
                                <div class="error mt-2 d-block ml-2" v-if="!$v.form.data_nascimento.idadeMinima"><small>Idade mínima para o beneficiário é de 16 anos.</small></div>
                            </div>

                            <div class="p-0 mb-3 col-12 d-md-flex">
                                <label class="mr-sm-1 col-md-2 p-0" for="nome_mae">Nome da mãe</label>
                                <b-form-input
                                    id="nome_mae"
                                    v-model="form.nome_mae"
                                    type="text"
                                    placeholder="Nome"
                                    required
                                    :class="`w-100`"
                                    @keyup.native="removeAcentos($event)"
                                    :disabled="consulta"
                                ></b-form-input>
                            </div>

                            <div class="p-0 mb-3 col-12 d-md-flex">
                                <label class="mr-sm-1 col-md-2 p-0" for="sexo">Sexo</label>
                                <b-form-radio-group
                                    id="sexo"
                                    v-model="$v.form.sexo.$model"
                                    :options="tipoSexo"
                                    :state="validar('sexo')" 
                                    :class="`w-100` + ($v.form.sexo.$error ? ` is-invalid` : ``)"
                                    :disabled="consulta"
                                >
                                </b-form-radio-group>
                            </div>

                            <div class="p-0 mb-3 col-12 d-md-flex">
                                <label class="mr-sm-1 col-md-2 p-0" for="tipo_documento">Tipo Documento</label>
                                <b-form-select
                                    id="tipo_documento"
                                    v-model="form.tipo_documento"
                                    :options="tipos"
                                    :class="`mb-2 mr-sm-1 mb-sm-0 col-md-3`"
                                    @change.native="changeTipoDocumento"
                                    :disabled="consulta"
                                ></b-form-select>

                                <label class="mr-sm-1 col-md-3 p-0" for="numero_documento">Número documento</label>
                                <the-mask
                                    id="numero_documento"
                                    pattern="[0-9\.\-]*"
                                    inputmode="numeric"
                                    mask="####################"
                                    placeholder="Somente números"
                                    :masked="false"
                                    v-model="form.numero_documento"
                                    type="text"
                                    required
                                    :class="`w-100 form-control`"
                                    :disabled="consulta"
                                ></the-mask>
                            </div>

                            <div class="p-0 mb-3 col-12 d-md-flex">
                                <label class="mr-sm-1 col-md-2 p-0" for="orgao_emissor">Órgão emissor</label>
                                <b-form-input
                                    id="orgao_emissor"
                                    v-model="form.orgao_emissor"
                                    type="text"
                                    required
                                    :class="`col-md-2 mb-2`"
                                    @keypress.native="isLetter($event)"
                                    @keyup.native="removeAcentos($event)"
                                    @change.native="changeOrgao()"
                                    :disabled="consulta"
                                ></b-form-input>

                                <label class="mr-sm-1 col-md-1 p-0" for="uf_orgao_emissor">UF</label>
                                <b-form-select
                                    id="uf_orgao_emissor"
                                    v-model="form.uf_orgao_emissor"
                                    :class="`mb-2 mr-sm-1 mb-sm-0`"
                                    :options="estados"
                                    :disabled="consulta"
                                ></b-form-select>

                                <label class="mr-sm-1 col-md-2 p-0" for="data_emissao">Data emissão</label>
                                <b-form-input
                                    id="data_emissao"
                                    v-model="form.data_emissao"
                                    type="date"
                                    required
                                    :class="`w-100` + ($v.form.data_emissao.$error ? ` is-invalid` : ``)"
                                    :disabled="consulta"
                                ></b-form-input>
                            </div>

                            <div class="error text-right w-100 mt-0" v-if="$v.form.data_emissao.$error">
                                <div v-if="!$v.form.data_emissao.menorQueHoje">
                                    <small>Data de emissão não pode ser maior que a data de hoje.</small>
                                </div>
                            </div>

                            <div class="p-0 mb-3 col-12 d-md-flex" v-if="form.tipo_documento == 3 || form.tipo_documento == 4">
                                <label class="mr-sm-1 col-md-2 p-0" for="data_validade" v-if="form.tipo_documento == 3">Validade documento</label>
                                <b-form-input
                                    id="data_validade"
                                    v-model="form.data_validade"
                                    type="date"
                                    required
                                    :class="`col-md-2 mb-2 w-100`"
                                    :disabled="form.tipo_documento != 3 || consulta"
                                    v-if="form.tipo_documento == 3"
                                ></b-form-input>

                                <label class="mr-sm-1 col-md-2 p-0" for="pais_emissao" v-if="form.tipo_documento == 3">País Emissão</label>
                                <b-form-select
                                    id="pais_emissao"
                                    v-model="form.pais_emissao"
                                    :options="paises"
                                    :class="`mb-2 mr-sm-1 mb-sm-0 col-md-2`"
                                    :disabled="form.tipo_documento != 3 || consulta"
                                    v-if="form.tipo_documento == 3"
                                ></b-form-select>

                                <label class="mr-sm-1 col-md-2 p-0" for="serie_documento" v-if="form.tipo_documento == 4">Série documento</label>
                                <b-form-input
                                    id="serie_documento"
                                    v-model="form.serie_documento"
                                    type="text"
                                    :class="`w-100`"
                                    :disabled="form.tipo_documento != 4 || consulta"
                                    v-if="form.tipo_documento == 4"
                                ></b-form-input>
                            </div>

                            <div class="p-0 mb-3 col-12 d-md-flex">
                                <label class="mr-sm-1 col-md-2 p-0" for="cep_endereco">Cep</label>
                                <the-mask
                                    id="cep_endereco"
                                    pattern="[0-9\.\-]*"
                                    inputmode="numeric"
                                    mask="#####-###"
                                    :masked="false"
                                    v-model="form.cep_endereco"
                                    type="text"
                                    required
                                    :class="`col-md-2 mb-2 form-control`"
                                    @input="buscaCep"
                                    :disabled="consulta"
                                ></the-mask>

                                <label class="mr-sm-1 col-md-2 p-0" for="numero_logradouro">Número</label>
                                <the-mask
                                    id="numero_logradouro"
                                    pattern="[0-9\.\-]*"
                                    inputmode="numeric"
                                    mask="######"
                                    :masked="false"
                                    v-model="form.numero_logradouro"
                                    type="text"
                                    required
                                    :class="`col-md-2 form-control`"
                                    :disabled="consulta"
                                ></the-mask>
                                <label class="mr-sm-1 col-md-2 p-0" for="bairro">Bairro</label>
                                <b-form-input
                                    id="bairro"
                                    v-model="form.bairro"
                                    type="text"
                                    required
                                    class="w-100"
                                    disabled
                                ></b-form-input>
                            </div>

                            <div class="p-0 mb-3 col-12 d-md-flex">
                                <label class="mr-sm-1 col-md-2 p-0" for="tipo_logradouro">Tipo Logradouro</label>
                                <b-form-input
                                    id="tipo_logradouro"
                                    v-model="form.tipo_logradouro"
                                    type="text"
                                    required
                                    :class="`col-md-1 mb-2`"
                                    disabled
                                ></b-form-input>

                                <label class="mr-sm-1 col-md-2 p-0" for="endereco">Logradouro</label>
                                <b-form-input
                                    id="endereco"
                                    v-model="form.endereco"
                                    type="text"
                                    required
                                    :class="`col-md-3 mb-2`"
                                    disabled
                                ></b-form-input>

                                <label class="mr-sm-1 col-md-2 p-0" for="complemento_logradouro">Complemento</label>
                                <b-form-input
                                    id="complemento_logradouro"
                                    v-model="form.complemento_logradouro"
                                    type="text"
                                    required
                                    class="w-100"
                                    @keyup.native="removeAcentos($event)"
                                    :disabled="consulta"
                                ></b-form-input>
                            </div>

                        </b-form>
                    </b-card>
                    <div class="text-center mt-3">
                        <b-row >  
                            <b-col class="text-left"> 
                                <b-button class="mr-2" variant="outline-secondary" @click="back">
                                    <font-awesome-icon                                                                      
                                        :icon="['fas','arrow-left']"
                                        title="Voltar"
                                        class="mr-1"
                                    />
                                    Voltar
                                </b-button>
                            </b-col>
                            <b-col class="text-right" v-if="!consulta"> 
                                <b-button variant="success" @click="salvar">
                                    <font-awesome-icon                                                                      
                                        :icon="['fas','save']"
                                        title="Salvar"
                                        class="mr-1"
                                    />
                                    Salvar
                                </b-button>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </div>
        </div>
        <b-modal header-bg-variant="warning" v-model="modalShow" title="ALERTA" ok-only centered>
            <p>{{ msgModal }}</p>
        </b-modal>
    </div>
</template>

<script>

import {
  required,
  //requiredIf,
} from "vuelidate/lib/validators";

import { TheMask } from "vue-the-mask";
import {paises, cnvTipoLogradouro,formatDate} from '../../../helpers';

export default {
    components: {
        TheMask,
    },
    data() {
        return {
            cpf_requerente: '',
            nome_completo: '',
            estados: ['AC','AL','AP','AM','BA','CE','DF','ES','GO','MA','MT','MS','MG','PA','PB','PR','PE','PI','RJ','RN','RS','RO','RR','SC','SP','SE','TO'],
            tipos: [
                { text: 'Selecione', value: null },
                { text: 'RG - Registro Geral', value: 1 },
                { text: 'CNH - Carteira Nacional de Habilitação', value: 2 },
                { text: 'Passaporte', value: 3 },
                { text: 'CTPS - Carteira de Trabalho e Previdência Social', value: 4 },
                { text: 'CIE - Carteira de Identidade de Estrangeiros', value: 5 },
                { text: 'RNE - Registro Nacional de Estrangeiros', value: 6 }
            ],
            paises: paises,
            form: {
                data_nascimento: '',
                nome_mae: '',
                nome_completo: '',
                ind_ativo: '',
                tipo_documento: null,
                numero_documento: '',
                orgao_emissor: '',
                uf_orgao_emissor: null,
                data_emissao: '',
                data_validade: '',
                pais_emissao: '',
                serie_documento: '',
                cep_endereco: '',
                numero_logradouro: '',
                tipo_logradouro: '',
                endereco: '',
                bairro: '',
                complemento_logradouro: '',
                logradouro: '',
                municipio: 'BELO HORIZONTE',
                sexo: ''
            },
            respAnterior:{
                cpf_requerente:'',
                data_nascimento: '',
                nome_mae: '',
                nome_completo: '',
            },
            modalShow: false,
            msgModal: "",
            consulta: false,
            tipoSexo: [
                { text: 'Masculino', value: 'M' },
                { text: 'Feminino', value: 'F' },
                { text: 'Outros', value: 'O' }
            ],
            tabIndex: 0
        }
    },
    validations: {
        form: {
            nome_completo: {
                required
            },
            data_nascimento: {
                //required,
                idadeMinima: (function (value) {                    
                    var dtNascimento = new Date(value);
                    dtNascimento.setFullYear(dtNascimento.getFullYear() + 16);

                    return dtNascimento < new Date();
                }),
            },
            sexo: {
                required
             },
            // nome_mae: {
            //     required
            // },
            // tipo_documento: {
            //     required
            // },
            // numero_documento: {
            //     required
            // },
            // orgao_emissor: {
            //     required
            // },
            // uf_orgao_emissor: {
            //     required
            // },
            data_emissao: {
                //required
                menorQueHoje: (function (value) {                    
                    var data = new Date(value);
                    return data < new Date();
                }),
            },
            // data_validade: {
            //     required: requiredIf(function() {
            //         return this.form.tipo_documento == 3;
            //     })
            // },
            // pais_emissao: {
            //     required: requiredIf(function() {
            //         return this.form.tipo_documento == 3;
            //     })
            // },
            // serie_documento: {
            //     required: requiredIf(function() {
            //         return this.form.tipo_documento == 4;
            //     })
            // },
            // cep_endereco: {
            //     required
            // },
            // numero_logradouro: {
            //     required
            // },
            // tipo_logradouro: {
            //     required
            // },
            // endereco: {
            //     required
            // }
        }
    },
    methods: {
        changeOrgao() {
        if(/^[a-zA-Z\s]*$/.test(this.form.orgao_emissor)) {
            return true; // Match with regex 
        }
        else this.form.orgao_emissor = '';
        },
        formatDate,
        validar(name) {
            const {$dirty, $error} = this.$v.form[name];
            return $dirty ? !$error : null;
        },

        async salvar() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                
                try {

                    const id = this.$route.params.id;
                    
                    if(this.form.bairro && this.form.logradouro) {
                        this.form.bairro = this.removeAcentosString(this.form.bairro);
                        this.form.logradouro = `${this.form.tipo_logradouro} ${this.form.endereco}, ${this.form.numero_logradouro} - ${this.form.bairro}`;
                    }

                    const result = await this.$api.put(`familias/${id}`, this.form);
                    if( !result.data.erro ) {
                        this.$helpers.showToast(this, 'Sucesso', result.data.message,'success');
                        //this.$router.push("/admin/beneficiarios");
                    }

                }catch(error) {
                    if(error.response.data){                        
                        this.$helpers.showToast(this,'Erro', error.response.data.message, 'danger');
                    }
                }
                
            }
        },
        back() {
            this.$router.back();
        },
        changeTipoDocumento() {
            setTimeout(() => { 
                if( this.form.tipo_documento != 3 ) {
                    this.form.data_validade = '';
                    this.form.pais_emissao = null;
                }

                if( this.form.tipo_documento != 4 ) {
                    this.form.serie_documento = '';
                }
            }, 1);
        },
        isLetter(e) {
            let char = String.fromCharCode(e.keyCode); // Get the character
            if(/^[a-zA-Z\s]*$/.test(char)) {
                return true; // Match with regex 
            }
            else e.preventDefault(); // If not match, don't add to input text
        },
        removeAcentos(e) {
            var texto = e.target.value;
            var semAcento = texto.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toUpperCase();
            e.target.value = semAcento;
        },
        removeAcentosString(string) {
            var texto = string;
            var semAcento = texto.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toUpperCase();
            return semAcento;
        },

        buscaCep() {
            if(this.form.cep_endereco.length == 8) {
                let query = this.form.cep_endereco;
                let url = `buscar-endereco?filtro=${query}`;
                this.$api.get(url)
                .then(response => {                    
                    if(response.status === 201){
                        var endereco = response.data.dados               
                        this.form.tipo_logradouro = endereco.tipo_logradouro ? cnvTipoLogradouro(endereco.tipo_logradouro) : null;
                        this.form.endereco = endereco.nome_logradouro;
                        this.form.bairro   = endereco.bairro_popular;
                    }
                })
                .catch(error => {  
                    if(error.response.data){
                        this.modalShow = true;
                        this.msgModal = error.response.data.message;                     
                    } 
                });
            }
        },

        async load() {
            try {

                const id = this.$route.params.id;
                const result = await this.$api.get(`familias/${id}`);
                const familia = result.data.familia;
                const familiaAnterior = result.data.familiaAnterior;
                if(familiaAnterior != null){
                    this.respAnterior.cpf_requerente = familiaAnterior.cpf_requerente;
                    this.respAnterior.nome_completo = familiaAnterior.nome_completo;
                    this.respAnterior.data_nascimento = familiaAnterior.data_nascimento;
                    this.respAnterior.nome_mae = familiaAnterior.nome_mae;
                } else{
                    this.respAnterior = null;
                }
                this.cpf_requerente = familia.cpf_requerente;
                this.nome_completo = familia.nome_completo;
                this.form.ind_ativo = familia.ind_ativo;
                this.form.data_nascimento = familia.data_nascimento;
                this.form.nome_completo = familia.nome_completo;
                this.form.nome_mae = familia.nome_mae;
                this.form.tipo_documento = familia.tipo_documento;
                this.form.numero_documento = familia.numero_documento;
                this.form.orgao_emissor = familia.orgao_emissor;
                this.form.uf_orgao_emissor = familia.uf_orgao_emissor;
                this.form.data_emissao = familia.data_emissao;
                this.form.data_validade = familia.data_validade;
                this.form.pais_emissao = familia.pais_emissao;
                this.form.serie_documento = familia.serie_documento;
                this.form.cep_endereco = familia.cep_endereco;
                this.form.numero_logradouro = familia.numero_logradouro;
                this.form.tipo_logradouro = familia.tipo_logradouro;
                this.form.endereco = familia.endereco;
                //this.form.logradouro = this.familia.logradouro;
                this.form.complemento_logradouro = familia.complemento_logradouro;
                this.form.bairro = familia.bairro;
                this.form.sexo = familia.sexo;

            }catch(error) {
                if(error.response.data){                        
                    this.$helpers.showToast(this,'Erro', error.response.data.message, 'danger');
                }
            }
            
        }
    }, 
    mounted() {
        this.load();
        if( this.$store.getters.userRoles.includes(this.$constantes.usuario.ROLES.CONSULTA )){
            this.consulta = true;
        }
    }
}
</script>

<style scoped>
.error {
  color: #dc3545;
}
</style>
